import React from "react";
import {
  getInstallmentStatusColor,
  translateInstallmentStatus,
} from "../../../utils/loan";
import { formatMoneyNumber } from "../../../utils/util";
import styles from "./style.module.css";

const InstallmentRow = ({ installment, installmentTitle, openingBalance }) => {
  const {
    total_amount,
    interest,
    principal,
    state: installmentStatus,
  } = installment;

  return (
    <tr style={{ backgroundColor: "white" }} className={styles.row}>
      <td className={styles.cell}>{installmentTitle}</td>
      <td className={styles.cell}>
        <p
          style={{
            color: getInstallmentStatusColor(installmentStatus),
            fontWeight: 600,
          }}
        >
          {translateInstallmentStatus(installment)}
        </p>
      </td>
      <td className={styles.cell}>
        {total_amount !== null ? formatMoneyNumber(total_amount) : ""}
      </td>
      <td className={styles.cell}>
        {interest !== null ? formatMoneyNumber(interest) : ""}
      </td>
      <td className={styles.cell}>
        {principal !== null ? formatMoneyNumber(principal) : ""}
      </td>
      <td className={styles.cell}>
        {openingBalance !== null ? formatMoneyNumber(openingBalance) : ""}
      </td>
    </tr>
  );
};

export default InstallmentRow;
